import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getSpaceDetails, getSpaceTopicDetails } from '../../CircleCommunityPage.duck';
import css from './TopicsComponent.module.css';
import { OutsideClickHandler } from '../../../../components';
import classNames from 'classnames';
import { parse } from '../../../../util/urlHelpers';
import { useHistory, useParams } from 'react-router-dom';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
const TopicsComponent = props => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const params = useParams();
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();

  const {
    topicId:selectedTopicId="all",
    ...rest
  }  = parse(window.location.search);

  const { spaceTopics, spaceDetail, isTopicId = null, currentPage } = props;
  const { records = [] } = spaceTopics || {};


  if (!records) return null;
  const moreTopicsRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const [visibleCount, setVisibleCount] = useState(window.innerWidth > 1320 ? 4 : 3);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  const fetchTopicDetails = topicId => {
    return history.push(
            createResourceLocatorString(
              currentPage,
              routeConfiguration,
              { ...params },
              {
                ...rest,
                ...(topicId ? {topicId} : {})
              }
            )
          );
  };

  const handleFetchAll = () => {
    dispatch(getSpaceDetails({ spaceId: spaceDetail?.id }))
  }

  // useEffect(() => {
  //   if (isTopicId) {
  //     setActiveItem(isTopicId);
  //     fetchTopicDetails(isTopicId);
  //   }
  // }, [isTopicId]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     const width = window.innerWidth;
  //     setIsDesktop(width > 1024);
  //     setVisibleCount(width > 1320 ? 4 : 3);
  //   };

  //   handleResize(); // Set initial values
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  const sortedRecords = [...records]?.sort((a, b) => a.name.length - b.name.length);

  const visibleItems = sortedRecords?.slice(0, visibleCount) || [];
  const hiddenItems = sortedRecords?.slice(visibleCount) || [];

  // useEffect(() => {
  //   if (isOpen && moreTopicsRef.current) {
  //     const rect = moreTopicsRef.current.getBoundingClientRect();
  //     setDropdownPosition({ top: rect.bottom + 5, right: window.innerWidth - rect.right });
  //   }
  // }, [isOpen]);

  return (
    <div className={css.filterSection}>
      <div
        className={`${css.filterTitle} ${selectedTopicId == 'all' ? css.activeFilterItems : ''}`}
        onClick={() => {
          // setActiveItem('all');
          // handleFetchAll();
          fetchTopicDetails();
        }}
      >
        All
      </div>
      <div className={css.filterDetails}>
        {visibleItems.map(item => (
          <div
            className={`${css.filterItems} ${selectedTopicId == item.id ? css.activeFilterItems : ''}`}
            key={item.id}
            onClick={() => {
              setActiveItem(item.id);
              fetchTopicDetails(item.id);
            }}
          >
            {item.name}
          </div>
        ))}

        {hiddenItems.length > 0 &&
          (isDesktop ? (
            <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
              <div
                onClick={() => setIsOpen(!isOpen)}
                className={classNames(css.filterTitle, css.dropdownDots, {
                  [css.activeFilterItems]: isOpen || hiddenItems.some(item => item.id == activeItem),
                })}
                ref={moreTopicsRef}
              >
                <span>More</span>
                {isOpen && (
                  <div
                    className={css.dropdownMenu}
                  // style={{
                  //   position: 'fixed',
                  //   top: dropdownPosition.top,
                  //   right: dropdownPosition.right,
                  // }}
                  >
                    <ul>
                      {hiddenItems.map(item => (
                        <li
                          key={item.id}
                          onClick={() => {
                            setActiveItem(item.id);
                            setIsOpen(false);
                            fetchTopicDetails(item.id);
                          }}
                          className={activeItem == item.id ? css.activeItem : ''}
                        >
                          {item.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </OutsideClickHandler>
          ) : (
            hiddenItems.map(item => (
              <div
                className={`${css.filterItems} ${activeItem == item.id ? css.activeFilterItems : ''}`}
                key={item.id}
                onClick={() => {
                  setActiveItem(item.id);
                  fetchTopicDetails(item.id);
                }}
              >
                {item.name}
              </div>
            ))
          ))}
      </div>
    </div>
  );
};

export default TopicsComponent;
